module.exports = __webpack_public_path__ + "img/album18_06.904bb760.jpg";